var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("VueJS Global Mixins and Plugins Example")]),_vm._v(" "),_c('p',[_vm._v("Tutorial at "),_c('a',{attrs:{"href":_vm.tutorialLink,"target":"_blank"}},[_vm._v("blog.mjshika.xyz")])]),_vm._v(" "),_c('img',{key:_vm.splashImage,staticClass:"splash-image",attrs:{"src":_vm.splashImage}}),_vm._v(" "),_c('home')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fdafba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Uq01
// module chunks = 0